import { render } from "./EmbeddedHeader.vue?vue&type=template&id=49ac4fbe&lang=pug"
import script from "./EmbeddedHeader.vue?vue&type=script&lang=js"
export * from "./EmbeddedHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__